<template>
  <div class="Melamine">
    <div class="title">Methyl Ethyl Ketone</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Items" label="Items"> </el-table-column>
        <el-table-column prop="Specification" label="Specification">
        </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>
        In 165KG/DRUM packing, 13.2MT/FCL, Or in 25CBM ISO TANK, 19.1MT/ISO
        TANK, or in bulk
      </p>
    </div>
    <!-- <div class="item-huanhang">
      <label>Applications:</label>
      <p>
        Forty-five percent of propylene glycol produced is useed as a chemical
        feedstock for the production of unsaturated polyester resins. Propylene
        glycol is also tused in various edible items such as coffee-based
        drinks, liquid sweeteners, ice cream, whipped dairy products and soda
        Antifreeze, Electronic cigarettes liquid etc.
      </p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        { Items: "Appearance", Specification: "Colorless & transparent" },
        { Items: "Purity %", Specification: "99.7min" },
        { Items: "Water %", Specification: "0.05 max" },
        {
          Items: "Boiling point-Distillation point °C",
          Specification: "78.5 min",
        },
        { Items: "Boiling point-Dry point °C", Specification: "81.0 max" },
        { Items: "Density, 20°C g/c m3", Specification: "0.804-0.806" },
        { Items: "Non-volatile matter (mg/100ml)", Specification: "5 max" },
        { Items: "color", Specification: "10 max" },
        { Items: "Acidity (base on acetic) %", Specification: "0.003 max" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
